<template>
  <div class="dashboard">
    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="header-left">
        <h1 class="title">📊 浙江vivo运营数据看板</h1>
        <span class="subtitle">实时消费数据概览</span>
      </div>
      <div class="header-right">
        <el-button type="primary" icon="el-icon-refresh" :loading="loading" @click="getData">
          刷新数据
        </el-button>
      </div>
    </div>

    <!-- 分组汇总卡片 -->
    <div class="summary-cards" v-loading="loading" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
      <div class="card-group" v-for="(sums, groupName) in groupSums" :key="groupName">
        <div class="group-header">
          <i class="el-icon-office-building"></i>
          <span>{{ groupName }}</span>
        </div>
        <div class="card-row">
          <div class="summary-card today">
            <div class="card-icon">
              <i class="el-icon-sunny"></i>
            </div>
            <div class="card-content">
              <span class="card-label">今日消费</span>
              <span class="card-value">¥{{ formatMoney(sums.totalToday) }}</span>
            </div>
          </div>
          <div class="summary-card yesterday">
            <div class="card-icon">
              <i class="el-icon-moon"></i>
            </div>
            <div class="card-content">
              <span class="card-label">昨日消费</span>
              <span class="card-value">¥{{ formatMoney(sums.totalYesterday) }}</span>
            </div>
          </div>
          <div class="summary-card compare">
            <div class="card-icon">
              <i class="el-icon-data-analysis"></i>
            </div>
            <div class="card-content">
              <span class="card-label">日环比</span>
              <span class="card-value" :class="getDayCompareClass(sums.totalToday, sums.totalYesterday)">
                {{ getDayCompare(sums.totalToday, sums.totalYesterday) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <div class="filter-left">
        <span class="filter-label">数据筛选</span>
        <el-radio-group v-model="selectedOption" @change="filterResults" size="medium">
          <el-radio-button label="全部">全部</el-radio-button>
          <el-radio-button label="运营">运营</el-radio-button>
          <el-radio-button label="销售">销售</el-radio-button>
        </el-radio-group>
      </div>
      <div class="filter-right">
        <el-tag type="info" effect="plain">
          <i class="el-icon-user"></i> 共 {{ tableData.length }} 人
        </el-tag>
        <el-tag type="warning" effect="plain">
          <i class="el-icon-coin"></i> 今日合计: ¥{{ formatMoney(totalTodayConsume) }}
        </el-tag>
        <el-tag type="success" effect="plain">
          <i class="el-icon-coin"></i> 昨日合计: ¥{{ formatMoney(totalYesConsume) }}
        </el-tag>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="table-section" v-loading="loading" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
      <div class="table-wrapper">
      <el-table
        :data="tableData"
        border
        :summary-method="summaryMethod"
        show-summary
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#f0f5ff', color: '#303133', fontWeight: '600' }"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="index" label="排名" width="70" align="center">
          <template slot-scope="scope">
            <span :class="getRankClass(scope.$index)">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="uname" label="用户名" min-width="120" align="center">
          <template slot-scope="scope">
            <span class="user-name">
              <i class="el-icon-user-solid"></i>
              {{ scope.row.uname }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="todayConsume" label="今日消费" min-width="150" align="right" sortable>
          <template slot-scope="scope">
            <span class="money today">¥{{ formatMoney(scope.row.todayConsume) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="yesConsume" label="昨日消费" min-width="150" align="right" sortable>
          <template slot-scope="scope">
            <span class="money yesterday">¥{{ formatMoney(scope.row.yesConsume) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="日环比" min-width="120" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="getCompareType(scope.row.todayConsume, scope.row.yesConsume)"
              size="small"
              effect="light"
            >
              {{ getCompareText(scope.row.todayConsume, scope.row.yesConsume) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </div>

    <!-- 底部提示 -->
    <div class="footer">
      <i class="el-icon-info"></i>
      <span>数据每分钟更新一次 | 今日消费 = 各子账户消费总和</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ZjAllData",
  data() {
    return {
      todayAll: [],
      yesAll: [],
      loading: false,
      groups: {
        '浙江运营组': ['杨晴', '唐莹', '桂小伟', '葛磊', '金霄', '朱丽华', '邓欣怡'],
      },
      users: [
        { uname: '朱丽华', uaccounts: ['Zhulihua01', 'Zhulihua02'] },
        { uname: '杨晴', uaccounts: ['yangqing01', 'yangqing02'] },
        { uname: '金霄', uaccounts: ['jinxiao01', 'jinxiao02'] },
        { uname: '唐莹', uaccounts: ['tangying1', 'tangying2'] },
        { uname: '桂小伟', uaccounts: ['fjxiaowei', 'zjxiaowei'] },
        { uname: '葛磊', uaccounts: ['zjgelei', 'fjgelei'] },
        { uname: '邓欣怡', uaccounts: ['zjdengxy', 'fjdengxy'] },
      ],
      result: [],
      tableData: [],
      selectedOption: '全部',
      zjcookie: '',
      fjcookie: ''
    };
  },
  created() {
    this.fetchHdCookieData();
  },
  computed: {
    groupSums() {
      const sums = {};
      for (const [groupName, members] of Object.entries(this.groups)) {
        const totalToday = this.result
          .filter(item => members.includes(item.uname))
          .reduce((total, item) => total + Number(item.todayConsume), 0);
        const totalYesterday = this.result
          .filter(item => members.includes(item.uname))
          .reduce((total, item) => total + Number(item.yesConsume), 0);
        sums[groupName] = { totalToday, totalYesterday };
      }
      return sums;
    },
    totalTodayConsume() {
      return this.tableData.reduce((total, item) => total + Number(item.todayConsume), 0);
    },
    totalYesConsume() {
      return this.tableData.reduce((total, item) => total + Number(item.yesConsume), 0);
    }
  },
  methods: {
    // 格式化金额
    formatMoney(value) {
      const num = Number(value);
      if (isNaN(num)) return '0.00';
      return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    // 获取日环比
    getDayCompare(today, yesterday) {
      const t = Number(today);
      const y = Number(yesterday);
      if (y === 0) return t > 0 ? '+100%' : '0%';
      const percent = ((t - y) / y * 100).toFixed(1);
      return percent > 0 ? `+${percent}%` : `${percent}%`;
    },

    // 日环比样式
    getDayCompareClass(today, yesterday) {
      const t = Number(today);
      const y = Number(yesterday);
      if (t > y) return 'up';
      if (t < y) return 'down';
      return 'equal';
    },

    // 表格日环比
    getCompareType(today, yesterday) {
      const t = Number(today);
      const y = Number(yesterday);
      if (t > y) return 'danger';
      if (t < y) return 'success';
      return 'info';
    },

    // 表格日环比文字
    getCompareText(today, yesterday) {
      const t = Number(today);
      const y = Number(yesterday);
      if (y === 0) return t > 0 ? '↑ 新增' : '-';
      const percent = ((t - y) / y * 100).toFixed(1);
      if (percent > 0) return `↑ ${percent}%`;
      if (percent < 0) return `↓ ${Math.abs(percent)}%`;
      return '持平';
    },

    // 排名样式
    getRankClass(index) {
      if (index === 0) return 'rank rank-1';
      if (index === 1) return 'rank rank-2';
      if (index === 2) return 'rank rank-3';
      return 'rank';
    },

    // 表格行样式
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) return 'even-row';
      return 'odd-row';
    },

    // Summary method
    summaryMethod({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
        } else if (index === 1) {
          sums[index] = `${data.length} 人`;
        } else {
          sums[index] = data.reduce((sum, row) => {
            const value = Number(row[column.property]);
            return sum + (isNaN(value) ? 0 : value);
          }, 0);
          sums[index] = '¥' + this.formatMoney(sums[index]);
        }
      });
      return sums;
    },

    // 筛选
    filterResults() {
      const yy = ['郑佳宇', '杨晴', '杨康', '夏富康', '唐莹', '朴盛霖', '桂小伟', '葛磊', '陈心瑜'];
      const xs = ['潘金林', '胡欢', '洪江涛'];

      if (this.selectedOption === '运营') {
        this.tableData = this.result.filter(item => yy.includes(item.uname));
      } else if (this.selectedOption === '销售') {
        this.tableData = this.result.filter(item => xs.includes(item.uname));
      } else {
        this.tableData = [...this.result];
      }
    },

    // 获取 cookie
    async fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = '';
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie;
        this.fjcookie = response.data.data.records[1].hdcookie;
        await this.getData();
      } catch (error) {
        console.error('错误:', error);
        this.$message.error('获取配置失败，请刷新重试');
      }
    },

    // 获取数据（并发）
    async getData() {
      this.loading = true;

      const fetchData = (url, cookie) => {
        return axios.get(url, { params: { cookie } }).then(res => res.data.adsAccountList);
      };

      const cookie1 = this.zjcookie;
      const cookie2 = this.fjcookie;

      try {
        const [
          [todayAll1, yesAll1],
          [todayAll2, yesAll2]
        ] = await Promise.all([
          Promise.all([
            fetchData("https://control.zjwec.cn/api/mmxuser/subAccountOverview", cookie1),
            fetchData("https://control.zjwec.cn/api/mmxuser/subOverview", cookie1)
          ]),
          Promise.all([
            fetchData("https://control.zjwec.cn/api/mmxuser/subAccountOverview", cookie2),
            fetchData("https://control.zjwec.cn/api/mmxuser/subOverview", cookie2)
          ])
        ]);

        this.todayAll = [...todayAll1, ...todayAll2];
        this.yesAll = [...yesAll1, ...yesAll2];

        this.result = this.users.map(user => {
          const todayConsume = user.uaccounts.reduce((total, account) => {
            const accountData = this.todayAll.find(item => item.subAccountName === account);
            return total + (accountData ? Number(accountData.totalConsume) : 0);
          }, 0);

          const yesConsume = user.uaccounts.reduce((total, account) => {
            const accountData = this.yesAll.find(item => item.subAccountName === account);
            return total + (accountData ? Number(accountData.totalConsume) : 0);
          }, 0);

          return {
            uname: user.uname,
            todayConsume: Number(todayConsume.toFixed(2)),
            yesConsume: Number(yesConsume.toFixed(2))
          };
        });

        this.tableData = [...this.result];
        this.$message.success('数据加载完成');
      } catch (error) {
        console.error("请求数据时出错:", error);
        this.$message.error('数据加载失败，请重试');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dashboard {
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
  min-height: 100vh;
}

/* 顶部标题 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.header-left {
  display: flex;
  flex-direction: column;
}

.title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

.subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 4px;
}

.header-right .el-button {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.6);
  color: #fff;
  font-weight: 500;
}

.header-right .el-button:hover {
  background: rgba(255, 255, 255, 0.35);
  border-color: #fff;
}

/* 汇总卡片 */
.summary-cards {
  margin-bottom: 24px;
  min-height: 120px;
}

.card-group {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}

.group-header {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f5ff;
}

.group-header i {
  margin-right: 8px;
  font-size: 20px;
  color: #667eea;
}

.card-row {
  display: flex;
  gap: 20px;
}

.summary-card {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.summary-card.today {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border-left: 4px solid #ff9800;
}

.summary-card.yesterday {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-left: 4px solid #2196f3;
}

.summary-card.compare {
  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
  border-left: 4px solid #9c27b0;
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.today .card-icon {
  background: rgba(255, 152, 0, 0.15);
  color: #ff9800;
}

.yesterday .card-icon {
  background: rgba(33, 150, 243, 0.15);
  color: #2196f3;
}

.compare .card-icon {
  background: rgba(156, 39, 176, 0.15);
  color: #9c27b0;
}

.card-icon i {
  font-size: 22px;
}

.card-content {
  display: flex;
  flex-direction: column;
}

.card-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 6px;
}

.card-value {
  font-size: 22px;
  font-weight: 700;
  color: #303133;
}

.card-value.up {
  color: #f56c6c;
}

.card-value.down {
  color: #67c23a;
}

.card-value.equal {
  color: #909399;
}

/* 筛选区域 */
.filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.filter-left {
  display: flex;
  align-items: center;
}

.filter-label {
  font-size: 14px;
  font-weight: 600;
  color: #606266;
  margin-right: 16px;
}

.filter-left .el-radio-group {
  margin-left: 0;
}

.filter-right {
  display: flex;
  gap: 12px;
}

.filter-right .el-tag {
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 8px;
}

/* 表格区域 */
.table-section {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  min-height: 300px;
}

.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-section .el-table {
  border-radius: 8px;
  overflow: hidden;
}

.table-section .el-table th {
  font-size: 14px;
}

.table-section .el-table td {
  font-size: 14px;
}

/* 排名样式 */
.rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 14px;
  background: #f0f2f5;
  color: #606266;
}

.rank-1 {
  background: linear-gradient(135deg, #ffd700 0%, #ffb800 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.4);
}

.rank-2 {
  background: linear-gradient(135deg, #c0c0c0 0%, #a8a8a8 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(192, 192, 192, 0.4);
}

.rank-3 {
  background: linear-gradient(135deg, #cd7f32 0%, #b8860b 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(205, 127, 50, 0.4);
}

/* 用户名 */
.user-name {
  font-weight: 500;
  color: #303133;
}

.user-name i {
  margin-right: 6px;
  color: #909399;
}

/* 金额 */
.money {
  font-weight: 600;
  font-family: 'DIN Alternate', 'Barlow', sans-serif;
}

.money.today {
  color: #ff9800;
}

.money.yesterday {
  color: #2196f3;
}

/* 表格斑马纹 */
.el-table .even-row {
  background: #fafafa;
}

.el-table .odd-row {
  background: #fff;
}

.el-table .even-row:hover > td {
  background: #f0f5ff !important;
}

.el-table .odd-row:hover > td {
  background: #f0f5ff !important;
}

/* 底部提示 */
.footer {
  margin-top: 20px;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
  color: #909399;
}

.footer i {
  margin-right: 6px;
}

/* 滚动条美化 */
.table-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .dashboard {
    padding: 12px;
  }

  /* 标题栏 */
  .header {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    margin-bottom: 16px;
  }

  .header .title {
    font-size: 18px;
  }

  .header .subtitle {
    font-size: 12px;
  }

  .header-right {
    margin-top: 12px;
    width: 100%;
  }

  .header-right .el-button {
    width: 100%;
  }

  /* 汇总卡片 */
  .card-group {
    padding: 16px;
    margin-bottom: 12px;
  }

  .group-header {
    font-size: 14px;
    margin-bottom: 12px;
    padding-bottom: 10px;
  }

  .card-row {
    flex-direction: column;
    gap: 10px;
  }

  .summary-card {
    padding: 12px 16px;
  }

  .card-icon {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  .card-icon i {
    font-size: 18px;
  }

  .card-label {
    font-size: 12px;
    margin-bottom: 4px;
  }

  .card-value {
    font-size: 18px;
  }

  /* 筛选区域 */
  .filter-section {
    flex-direction: column;
    padding: 12px 16px;
    gap: 12px;
  }

  .filter-left {
    width: 100%;
  }

  .filter-label {
    font-size: 13px;
    margin-right: 12px;
  }

  .el-radio-group {
    display: flex;
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #667eea;
    border-color: #667eea;
  }

  .filter-right {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    width: 100%;
  }

  .filter-right .el-tag {
    font-size: 12px;
    padding: 6px 10px;
    text-align: center;
    justify-content: center;
  }

  /* 表格区域 */
  .table-section {
    padding: 12px;
    border-radius: 8px;
  }

  .table-wrapper {
    margin: 0 -12px;
    padding: 0 12px;
  }

  .el-table {
    min-width: 500px;
  }

  .el-table {
    font-size: 13px;
  }

  .el-table th,
  .el-table td {
    padding: 8px 0;
  }

  .rank {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }

  .user-name {
    font-size: 13px;
  }

  .money {
    font-size: 13px;
  }

  .el-tag--small {
    font-size: 11px;
    padding: 2px 6px;
  }

  /* 底部提示 */
  .footer {
    padding: 10px 16px;
    font-size: 11px;
    margin-top: 12px;
  }
}

/* 小屏手机适配 */
@media screen and (max-width: 480px) {
  .dashboard {
    padding: 8px;
  }

  .header {
    padding: 12px;
    margin-bottom: 12px;
  }

  .header .title {
    font-size: 16px;
  }

  .card-group {
    padding: 12px;
  }

  .summary-card {
    padding: 10px 12px;
  }

  .card-value {
    font-size: 16px;
  }

  .filter-right {
    grid-template-columns: 1fr;
  }

  .el-table {
    font-size: 12px;
  }

  .el-table th,
  .el-table td {
    padding: 6px 0;
  }

  .el-table .cell {
    padding-left: 6px;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/zjAllData.vue